import Vue from 'vue'
import Vuex from 'vuex'
//引入vuex中的模块
import intro from './intro'
import material from './material'
import about from './about'
import politicalParty from './politicalParty'
import kindness from './kindness'
import humanResource from './humanResource'
import news from './news'
import research from './research'
import groupProducts from './groupProducts'

Vue.use(Vuex)

const actions = {}

const muations = {}

const state = {}

const getters = {}

export default new Vuex.Store({
	modules:{
		intro,
		material,
		about,
		politicalParty,
		kindness,
		humanResource,
		news,
		research,
		groupProducts,
	},
	actions,
	muations,
	state,
	getters,
})